module.exports = __webpack_public_path__ + "static/media/bfile-user.7d73cf28.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-user.svg
// module id = 975
// module chunks = 0